import React, { JSX } from 'react';
import {
    Edit,
    SimpleForm,
    SelectField,
    ReferenceField,
    TextInput,
    required,
    BooleanInput,
    NumberField,
    BooleanField,
    TextField, Toolbar, SaveButton
} from 'react-admin';
import {
    LinearProgress,
    Box,
    Stack
} from '@mui/material';
import { currency, frequency } from "../../defaults/defaults";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

const ToolBar: () => JSX.Element = (): JSX.Element => {
    return (
        // HQ-22. `usePermissions` and `DeleteButton` were imported here and never used, which
        // reads as a gate that is present. There is no delete control on this screen, and Save is
        // behind the edit route, which react-admin refuses without HQ_Sales::product_prices.
        <Toolbar sx={ { display: 'flex', justifyContent: 'space-between' } }>
            <SaveButton />
        </Toolbar>
    );
}

export const SubscriptionProductPriceEdit: () => JSX.Element = (): JSX.Element => {

    return (
        <Edit redirect={ false }>
            <SimpleForm toolbar={ <ToolBar /> } >
                <Stack spacing={ 2 } sx={ { width: '100%', margin: '0 0 40px 0' } } >
                    <Box sx={ { width: '100%', margin: '10px 0', display: 'flex', justifyContent: 'space-between', fontSize: '1.2rem' } } >
                        <span>{ "Name:" }</span>
                        <TextField source="name" sx={ { fontSize: '1.2rem' } } />
                    </Box>
                    <Box sx={ { width: '100%', margin: '10px 0', display: 'flex', justifyContent: 'space-between', fontSize: '1.2rem' } } >
                        <span>{ "Currency:" }</span>
                        <SelectField source="currency" choices={ currency } sx={ { fontSize: '1.2rem', textTransform: 'uppercase' } } />
                    </Box>
                    <Box sx={ { width: '100%', margin: '10px 0', display: 'flex', justifyContent: 'space-between', fontSize: '1.2rem' } } >
                        <span>{ "Price" }</span>
                        <TextField source="price" sx={ { fontSize: '1.2rem' } } />
                    </Box>
                    <Box sx={ { width: '100%', margin: '10px 0', display: 'flex', justifyContent: 'space-between', fontSize: '1.2rem' } } >
                        <span>{ "Live Mode:" }</span>
                        <BooleanField source="liveMode" sx={ { fontSize: '1.2rem' } } />
                    </Box>
                    <Box sx={ { width: '100%', margin: '10px 0', display: 'flex', justifyContent: 'space-between', fontSize: '1.2rem' } } >
                        <span>{ "Price Frequency Count:" }</span>
                        <NumberField source="priceFrequencyCount"  sx={ { fontSize: '1.2rem',  } } />
                    </Box>
                    <Box sx={ { width: '100%', margin: '10px 0', display: 'flex', justifyContent: 'space-between', fontSize: '1.2rem' } } >
                        <span>{ "Price Frequency:" }</span>
                        <SelectField source="priceFrequency" choices={ frequency } sx={ { fontSize: '1.2rem' } } />
                    </Box>
                    <Box sx={ { width: '100%', margin: '10px 0', display: 'flex', justifyContent: 'space-between', fontSize: '1.2rem' } } >
                        <span>{ "Subscription Product:" }</span>
                        <ReferenceField source="subscriptionProduct" reference="subscription_products"  sx={ { fontSize: '1.2rem',  } }  />
                    </Box>
                </Stack>
                <BooleanInput source="active" name="active" />
                <BooleanInput source="defaultPrice" name="defaultPrice" />
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Edit>
    );
}
